import React, { memo } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { Stack, FormLabel, FormControl, FormErrorMessage } from "@chakra-ui/react";
import { SelectFieldStandard } from "../Select";

const days = Array.from({ length: 31 }, (_, index) => {
  const day = index + 1;
  return { label: day, value: day };
});
const currentYear = new Date().getFullYear();
const years = Array.from(new Array(120), (_, idx) => {
  const year = currentYear - idx;
  return { label: year, value: year };
});

function DOBSelectField({ minAgeValidationError, locale }) {
  const { formatMessage } = useIntl();
  const months = Array.from({ length: 12 }, (_, i) => ({
    label: new Date(0, i).toLocaleString(locale, { month: "long" }),
    value: i + 1,
  }));

  return (
    <Stack spacing={0} direction="column">
      <FormLabel htmlFor="personal.dob.day">
        <FormattedMessage defaultMessage="Date of birth" description="Form label" />
      </FormLabel>
      <Stack direction={["column", "row"]}>
        <SelectFieldStandard
          name="personal.dob.day"
          placeholder={formatMessage({ defaultMessage: "Day", description: "Input field label" })}
          options={days}
          aria-label="Day of birth"
        />
        <SelectFieldStandard
          name="personal.dob.month"
          placeholder={formatMessage({ defaultMessage: "Month", description: "Input field label" })}
          options={months}
          aria-label="Month of birth"
        />
        <SelectFieldStandard
          name="personal.dob.year"
          placeholder={formatMessage({ defaultMessage: "Year", description: "Input field label" })}
          options={years}
          aria-label="Year of birth"
        />
      </Stack>
      {!!minAgeValidationError && (
        <FormControl isInvalid={!!minAgeValidationError}>
          <FormErrorMessage>{minAgeValidationError}</FormErrorMessage>
        </FormControl>
      )}
    </Stack>
  );
}

export default memo(DOBSelectField);
